import { createUseStyles } from 'react-jss'
import { required, sarabunFont } from '../Styles'
import customColors from 'src/config/colorsV2'
import { Theme } from '@mui/material/styles'

export const INFO_STYLES = {
  ...sarabunFont({ size: 13 }),
  marginLeft: 16,
  color: customColors.mainText,
}

export default createUseStyles(
  (theme: Theme) => ({
    root: {
      ...sarabunFont({ size: 16 }),
      position: 'relative',

      '& .inputWrapperIconSpace': {
        '& input': {
          paddingLeft: [36],
        },

        '& input:focus + div, & input:not(:placeholder-shown) + div': {
          left: 46,
        },
      },

      '& .inputWrapper': {
        position: 'relative',
        '& input': {
          ...sarabunFont({ size: 16 }),
          padding: [18, 20, 6, 20],
          margin: 0,
          borderWidth: 0,
          borderBottom: `1px solid ${customColors.border}`,
          outline: 'none',
        },
        '& input:focus': {
          borderColor: theme.palette.primary.main,
          '& + div': {
            color: theme.palette.primary.main,
          },
        },
        '& input:focus + div, & input:not(:placeholder-shown) + div': {
          transform: `scale(0.75)`,
          top: -2,
          left: 10,
        },
      },

      '& .inputIconSpace': {
        paddingLeft: '56px!important',
      },
    },
    icon: {
      pointerEvents: 'none',
      position: 'absolute',
      top: 10,
      left: 16,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',

      '& svg': {
        width: [20],
        height: [20],
      },

      '& svg > path': {
        fill: theme.palette.grey[800],
      },
    },
    placeholder: {
      pointerEvents: 'none',
      position: 'absolute',
      top: 10,
      left: 16,
      transition: '0.1s ease-in-out',
      color: theme.palette.grey['700'],
    },
    placeholderIconSpace: {
      left: 52,
    },
    required: required(theme),
    info: INFO_STYLES,
  }),
  { name: 'Input' }
)
